import React from 'react';
import { Page } from '../../components';
import { LoginForm } from '../../components/Auth';

export const Login = ({ navigation }: any) => {
  return (
    <Page title={'Login'}>
      <LoginForm navigation={navigation} inPage={true} />
    </Page>
  );
};
